import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CommonAreasTable from "../../components/CommonAreasTable";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import {
  fetchFaqsNotesDocuments,
  saveFaqsNotesDocuments,
  deleteFaqsNotesDocuments,
} from "../../store/actions/faqsNotesDocuments";
import { selectDocuments } from "../../store/selectors/faqsNotesDocuments";
import { setSearch, clearSearch } from "../../store/actions/search";
import { upload } from "../../helpers/uploadDocument";
import moment from "moment";
import { clearSelectedPropertyCommonAreas,fetchPropertyCommonAreas } from "../../store/actions/properties";
import { selectPropertyCommonAreas } from "../../store/selectors/propertyCommonAreas";
import { fetchCommonAreas } from "../../store/actions/commonAreas";
import { selectPRLoader } from "../../store/selectors/PropertyLoader";
import Loader from "../../components/Loader";

class PropertyCommonAreas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commonAreas: [],
    };
  }

  onSearch(e) {
    let filterdData = this.props.propertyCommonAreas.commonAreas.filter(
      (item) => item.name.toLowerCase().includes(e.toLowerCase())
    );
    this.setState({ commonAreas: filterdData });
  }

  componentDidMount() {
    const { property, onFetchPropertyCommonAreas, onFetchCommonAreas, loader,clearSelectedPropertyCommonAreas } =
      this.props;
    clearSelectedPropertyCommonAreas();
    onFetchPropertyCommonAreas(property.propertyId,loader);
    setTimeout(
      () =>
        this.setState({
          commonAreas: this.props.propertyCommonAreas.commonAreas, }),             
      2000
    );
  }

  render() {
    const { property, propertyCommonAreas, check, setSearch, loader } = this.props;
    return (
      loader ? <Loader /> :
      <CommonAreasTable
        commonAreas={this.state.commonAreas}
        property={property}
        onSearch={(e) => this.onSearch(e.target.value.trim())}
        triggerCommonAreas={(e) => {
          console.log("Triggered....");
          this.props.onFetchCommonAreas();
          this.props.onFetchPropertyCommonAreas(property.propertyId);
          setTimeout(
            () =>
              this.setState({
                commonAreas: this.props.propertyCommonAreas.commonAreas, }),             
            2000
          );
        }}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  documents: selectDocuments(state),
  propertyCommonAreas: selectPropertyCommonAreas(state),
  check: state,
  loader: selectPRLoader(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchPropertyCommonAreas: fetchPropertyCommonAreas,
      onFetchCommonAreas: fetchCommonAreas,
      setSearch,
      clearSearch,
      clearSelectedPropertyCommonAreas,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyCommonAreas);
